<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form
        @submit.prevent="filterDiscountCoupon"
        ref="form"
        class="search-forms"
      >
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.filter')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              hide-details
              clearable
            ></BaseTextField>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              :label="$t('reports.sales-by-coupon.coupon-code')"
              :placeholder="$t('reports.sales-by-coupon.insert-coupon-code')"
              v-model="filter.couponCode"
              type="text"
            />
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <BaseAutocomplete
              v-model="filter.product"
              :label="$t('reports.sales-by-event.event')"
              :placeholder="$t('reports.sales-by-event.select')"
              :no-data-text="$t('reports.sales-by-event.no-events-found')"
              :items="allEvents"
              :loading="$produtos_gerenciar.produtos_loading"
              data-cy="produto"
              loader-height="5"
              item-text="descricao"
              item-value="idproduto"
              clearable
              @click:clear="filter.product = ''"
            />
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              variant="filter"
              type="submit"
              :loading="discountCouponLoading"
            >
              {{ $t("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="rounded-lg"
      hide-details
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      :loading="discountCouponLoading"
      :headers="headers"
      :items="allDiscountCoupon.info"
      :items-per-page="10"
      mobile-breakpoint="0"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.sales-per-page'),
      }"
    >
      <template v-slot:item.total_desconto_cupom="{ item }">
        {{ item.total_desconto_cupom | moeda }}
      </template>
      <template v-slot:item.ult_dthr_cupom_aplicado="{ item }">
        {{ item.ult_dthr_cupom_aplicado | dthr_pt_br }}
      </template>
      <template v-slot:item.total_valor_liquido="{ item }">
        {{ item.total_valor_liquido | moeda }}
      </template>
    </v-data-table>
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "DiscountCoupon",
  props: {},
  components: {
    DateTimePicker,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    ExpansionPanelFilters,
  },
  data() {
    return {
      filter: {
        pesquisar: "",
        couponCode: "",
        product: "",
        initDateTime: "",
        endDateTime: "",
      },
      dayjs: dayjs,
    };
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "intervalDates",
      "allDiscountCoupon",
      "discountCouponLoading",
      "allEvents",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.sales-by-coupon.coupon-code"),
          align: "start",
          sortable: false,
          value: "codigo",
          width: 200,
        },
        {
          text: this.$t("reports.sales-by-coupon.usage-date-hour"),
          align: "start",
          value: "ult_dthr_cupom_aplicado",
          width: 200,
        },
        {
          text: this.$t("reports.sales-by-coupon.remaining-quantity"),
          align: "end",
          value: "qtd_restante",
          width: 200,
        },
        {
          text: this.$t("reports.sales-by-coupon.used-quantity"),
          align: "end",
          value: "qtd_utilizado",
          width: 200,
        },
        {
          text: this.$t("reports.sales-by-coupon.bought-tickets"),
          align: "end",
          value: "qtd_itens_vendidos",
          width: 180,
        },
        {
          text: this.$t("reports.sales-by-coupon.discount-value"),
          align: "end",
          value: "total_desconto_cupom",
          width: 200,
        },
        {
          text: this.$t("reports.sales-by-coupon.net-value-generated"),
          align: "end",
          value: "total_valor_liquido",
          width: 180,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchDiscountCouponReport", "fetchEvents"]),
    ...mapMutations(["setDiscountCouponLoading", "setReportsFilter"]),
    filterDiscountCoupon() {
      this.setDiscountCouponLoading(true);
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_cupom_aplicado_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_cupom_aplicado_fim: this.filter.endDateTime,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        codigo: this.filter.couponCode,
        idproduto: this.filter.product,
        pesquisar: this.filter.pesquisar,
      });

      this.setReportsFilter(filter);
      this.fetchDiscountCouponReport(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterDiscountCoupon();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
  },
  mounted() {
    if (this.storeSequencial) {
      this.$loja_consumidor.getConsumidor(this.storeSequencial);
      this.fetchEvents({ producerId: this.storeSequencial, filtro: [] });
      this.fetchDiscountCouponReport({ producerId: this.storeSequencial });
    }
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      couponCode: "",
      product: "",
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>
<style scoped></style>
